import { TextField } from '@mui/material';
import React, { useState } from 'react';

interface TimePickerProps {
  value?: time;
  onChange: (time: time) => void;
}
interface time {
  hour: number;
  minute: number;
}

const PickerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9882 1.48846C11.9519 1.48924 11.9157 1.49267 11.8799 1.49871H9.75C9.65062 1.4973 9.55194 1.51567 9.45972 1.55273C9.36749 1.58979 9.28355 1.64481 9.21277 1.71459C9.142 1.78437 9.08579 1.86753 9.04743 1.95922C9.00907 2.05091 8.98932 2.14932 8.98932 2.24871C8.98932 2.3481 9.00907 2.44651 9.04743 2.5382C9.08579 2.62989 9.142 2.71305 9.21277 2.78283C9.28355 2.85261 9.36749 2.90763 9.45972 2.94469C9.55194 2.98175 9.65062 3.00012 9.75 2.99871H11.25V4.53681C6.6387 4.92027 3 8.79028 3 13.4986C3 18.4603 7.0383 22.4986 12 22.4986C16.9617 22.4986 21 18.4603 21 13.4986C21 11.2873 20.1942 9.26211 18.8657 7.69341L19.9541 6.60501L20.4859 7.13528C20.555 7.20711 20.6378 7.26443 20.7293 7.30389C20.8209 7.34335 20.9194 7.36416 21.0191 7.36511C21.1188 7.36605 21.2177 7.34711 21.31 7.3094C21.4023 7.27168 21.4861 7.21595 21.5566 7.14545C21.6271 7.07495 21.6828 6.9911 21.7206 6.89881C21.7583 6.80652 21.7772 6.70764 21.7763 6.60794C21.7753 6.50825 21.7545 6.40974 21.715 6.31818C21.6756 6.22663 21.6183 6.14385 21.5464 6.07471L20.5825 5.11231C20.5321 5.03929 20.4691 4.97581 20.3965 4.92481L19.4238 3.95213C19.3539 3.88029 19.2703 3.82318 19.178 3.78418C19.0857 3.74518 18.9865 3.72509 18.8862 3.72508C18.737 3.72512 18.5912 3.76966 18.4675 3.85299C18.3437 3.93633 18.2476 4.05468 18.1915 4.19291C18.1353 4.33115 18.1217 4.48298 18.1523 4.62901C18.1829 4.77504 18.2563 4.90862 18.3633 5.01268L18.8935 5.54442L17.8051 6.63282C16.4161 5.45644 14.6677 4.69609 12.75 4.53664V2.99854H14.25C14.3494 2.99995 14.448 2.98159 14.5403 2.94453C14.6325 2.90747 14.7164 2.85245 14.7872 2.78266C14.858 2.71288 14.9142 2.62973 14.9526 2.53803C14.9909 2.44634 15.0107 2.34794 15.0107 2.24854C15.0107 2.14915 14.9909 2.05075 14.9526 1.95906C14.9142 1.86736 14.858 1.78421 14.7872 1.71442C14.7164 1.64464 14.6325 1.58962 14.5403 1.55256C14.448 1.5155 14.3494 1.49714 14.25 1.49854H12.1157C12.0736 1.49151 12.0309 1.48824 11.9882 1.48846ZM11.9121 6.00308C11.9724 6.01044 12.0334 6.01044 12.0937 6.00308C14.0781 6.02752 15.8713 6.81728 17.1972 8.09198C17.2523 8.17384 17.323 8.24403 17.4053 8.29852C18.7015 9.64575 19.5 11.4755 19.5 13.4987C19.5 17.6497 16.151 20.9987 12 20.9987C7.84898 20.9987 4.5 17.6497 4.5 13.4987C4.5 9.3774 7.8023 6.05048 11.9121 6.00308Z"
      fill="#1D3679"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9883 8.98837C11.7896 8.99148 11.6003 9.07327 11.4619 9.21581C11.3235 9.35835 11.2473 9.54998 11.25 9.74865V12.1978C11.0224 12.3297 10.8333 12.5193 10.7017 12.7476C10.57 12.9759 10.5005 13.2349 10.5 13.4986C10.4999 13.6964 10.5387 13.8922 10.614 14.0749C10.6894 14.2576 10.7998 14.4236 10.9391 14.5634C11.0784 14.7032 11.2438 14.8142 11.4258 14.8899C11.6079 14.9655 11.803 15.0045 12 15.0045C12.197 15.0045 12.3921 14.9655 12.5742 14.8899C12.7562 14.8142 12.9216 14.7032 13.0609 14.5634C13.2002 14.4236 13.3106 14.2576 13.386 14.0749C13.4613 13.8922 13.5001 13.6964 13.5 13.4986C13.4998 13.2347 13.4303 12.9754 13.2987 12.7468C13.1671 12.5182 12.9778 12.3284 12.75 12.1964V9.74865C12.7514 9.6483 12.7326 9.54871 12.6948 9.45575C12.657 9.36279 12.6009 9.27837 12.5299 9.20748C12.4589 9.13658 12.3743 9.08066 12.2813 9.04303C12.1883 9.00539 12.0886 8.98681 11.9883 8.98837Z"
      fill="#1D3679"
    />
  </svg>
);

const CustomTimeAdder = ({ value, onChange }: TimePickerProps) => {
  const [hour, setHour] = useState(value?.hour || 0);
  const [minute, setMinute] = useState(value?.minute || 0);

  const handleHourChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.slice(0, 2);
    }
    const newHour = parseInt(value);

    setHour(newHour);
    onChange({ hour: newHour, minute });
  };

  const handleMinuteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.slice(0, 2);
    }
    const newMinute = parseInt(value);
    setMinute(newMinute);
    onChange({ hour, minute: newMinute });
  };

  return (
    <div className=" w-[504px] flex justify-between items-center border border-cgray-3 px-[14px] py-3">
      <div className="w-12 flex gap-1 items-center">
        <input
          type="text"
          className="w-[3ch] text-center outline-none"
          value={hour}
          onChange={handleHourChange}
        />
        {':'}
        <input
          type="text"
          className="w-[3ch] text-center outline-none"
          value={minute}
          onChange={handleMinuteChange}
        />
      </div>
      <PickerIcon />
    </div>
  );
};

export default CustomTimeAdder;
